export default {
  setList(state, list) {
    state.list = [...state.list, ...list];
  },

  initList(state) {
    state.pageInfo.page = 1;
    state.pageInfo.totalPage = 2;
    state.condition.page = 1
    state.list = [];
  },

  setPage(state, page = 1) {
    state.condition.page = page;
  },

  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },

  setTotalPage(state, totalPage = 2) {
    state.pageInfo.totalPage = totalPage;
  }
};
